import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from './WrapperByRole'

const PersonWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='person' {...props} />

export default PersonWrapper